import React, { Fragment, useEffect } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import TestimonyProgramPost from '../../../Component/Learning/TestimonyProgram/TestimonyProgramPost';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setField, resetState } from '../../../Features/Learning/TestimonyProgram/addTestimonyProgramSlice';
import { fetchTestimonyProgram } from '../../../Features/Learning/TestimonyProgram/Utils/TestimonyProgramUtils';
import { handleEditTestimonyProgram } from '../../../Component/Learning/TestimonyProgram/TestimonyProgramUtils';

const TestimonyProgramForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const addField = useSelector(state => state.addTestimonyProgram)
  const filters = useSelector(state => state.testimonyProgram.filters)

  useEffect(() => {
    if (!addField.id && id) {
      const newFilters = {
        ...filters,
        "filter[id]": id,
        "page": 1,
      };
      dispatch(fetchTestimonyProgram(newFilters))
        .then((response) => {
          // Kode yang akan dijalankan setelah fetch sukses
          handleEditTestimonyProgram(dispatch, response.payload.data[0], setField)
        })
        .catch((error) => {
          // Tangani error jika fetch gagal
          console.error('Error during fetch Testimony Program:', error);
        });
    } else if (!id) {
      dispatch(resetState());
      console.log(addField, "addField");
    }
  }, [id]);


  return (
    <Fragment>
      <Breadcrumbs greatgrandparent="Learning" grandparent="Testimony Program" title={id ? "Ubah Testimony Program" : "Tambah Testimony Program"} />
      <TestimonyProgramPost />
    </Fragment>
  );
};

export default TestimonyProgramForm;